import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { doKeycloakLogin } from "../services/keycloak";
import { useAuth } from "../contexts/AuthContext";

const Login = ({ state }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  const from = state?.from?.pathname || location.state?.from?.pathname || "/";

  useEffect(() => {
    console.log("Login component mounted");

    if (currentUser) {
      navigate(from, { replace: true });
      return;
    } else {
      doKeycloakLogin(from);
    }
  }, [currentUser, navigate, from]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Login;
